let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("512a4")).then(() => parcelRequire('1lUBb'));